import { Stack, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { WithTooltip } from 'src/components';
import { componentsFontSizes } from 'src/constants/layout';
import { useCopyToClipboard } from 'src/utils/hooks';
import { PartnerTabContactPartner } from './partner-contact-info';

interface PartnerTabProps {
  partner: PartnerTabContactPartner | null;
}

export const PartnerInfo = ({ partner }: PartnerTabProps) => {
  const theme = useTheme();
  const { copyToClipboard } = useCopyToClipboard();

  const conversationPartnerInfo = useMemo(() => {
    if (!partner) {
      return [];
    }

    return [
      {
        label: 'Support Phone',
        value: partner.supportPhone,
      },
      {
        label: 'Support Email',
        value: partner.supportEmail,
      },
      {
        label: 'Support Live Date',
        value: partner.supportLiveDate,
        hideTooltip: true,
      },
      {
        label: 'LitS Date',
        value: partner.litsDate,
        hideTooltip: true,
      },
    ];
  }, [partner]);

  return (
    <Stack gap={0.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" py={1}>
        <Typography variant="overline" fontSize="0.75rem">
          General Information
        </Typography>
      </Stack>
      <Stack gap={2} paddingInline={2}>
        {conversationPartnerInfo.map((field) => (
          <Stack direction="row" spacing={2} justifyContent="space-between" key={field.label}>
            <Typography variant="subtitle2" color={theme.palette.custom.OV.sys.outline}>
              {field.label}
            </Typography>
            <WithTooltip hideTooltip={field.hideTooltip} title="Click to copy">
              <Typography
                variant="body2"
                sx={{
                  cursor: field.hideTooltip ? 'initial' : 'pointer',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: componentsFontSizes.input,
                }}
                onClick={async () => {
                  if (field.value) {
                    await copyToClipboard(field.value);
                  }
                }}
              >
                {field.value}
              </Typography>
            </WithTooltip>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
